import React from 'react';

type Props = {};

export default function GridFill({}: Props) {
	return <div className="min-w-[30px] min-h-[30px] rounded-lg bg-red-900"></div>;
}
